import React from "react";
import "./infoboxs.scss";
import { IconATotalProject, IconFinance } from "../../../icon/icons";
import Price from "../../layout/price";
import { useNavigate } from "react-router-dom";

const infoMapping = [
  {
    key: "totalDrivers",
    label: "Total Driver",
    icon: <IconATotalProject />,
    iconClass: "icon-green",
    isPrice: false,
    navigation: "/customers/driver",
  },

  {
    key: "totalClients",
    label: "Total Client",
    icon: <IconATotalProject />,
    iconClass: "icon-green",
    isPrice: false,
    navigation: "/customers/client",
  },

  {
    key: "totalOrders",
    label: "Total Orders",
    icon: <IconFinance />,
    iconClass: "icon-blue",
    isPrice: false,
    navigation: "/orders",
  },
];

const InfoBoxs = ({ listData }) => {
  const navigate = useNavigate();
  return (
    <div className="info-boxs-main-components">
      <div className="flex-data-box">
        {infoMapping.map((item, index) => (
          <div
            className="card-data-main"
            key={index}
            onClick={() => navigate(item?.navigation)}
          >
            <div className={`icon-image ${item.iconClass}`}>{item.icon}</div>
            <div className="text-data-new">
              <span>{item.label}</span>

              <div className="price-all-main">
                <Price
                  price_main={listData?.[item.key] || 0}
                  price_symbol={item?.isPrice ? "$" : ""}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoBoxs;
